@use "variables" as *;
@use "common/config/breakpoints";

.searchWrapper {
  display: flex;
  flex-direction: row;
  gap: $spacing-2;
  margin-bottom: $spacing-4;
}

.input {
  flex-grow: 1;

  @media (min-width: (breakpoints.$breakpoint-sm)) {
    flex-grow: 0;
    width: 350px;
  }
}

.clearIcon {
  height: 100% !important;
}
